import { NgModule } from '@angular/core';
import { CommonModule, CommonModule as NgCommon } from '@angular/common';
import { CwIconComponent } from './icon/icon.component';
import { CwLoaderComponent } from './loader/loader.component';
import { CwLoaderService } from './loader/loader.service';
import { CwLoaderInlineComponent } from './loader/loader-inline.component';
import { CwContactSupportModule } from './contact-support/contact-support.module';
import { LinearChartComponent } from './linear-chart/linear-chart.component';
import { PlainLoaderComponent } from './plain-loader/plain-loader.component';
import { CwErrorComponent } from './error/error.component';
import { ChartErrorComponent } from './chart-error/chart-error.component';
import { CwInputComponent } from './input/input.component';
import { CwRadioButtonComponent } from './radio-button/radio-button.component';
import { CwSelectComponent } from './select/select.component';
import { CwStepperComponent } from './stepper/stepper.component';
import { CwStepperItemComponent } from './stepper/components/stepper-item/stepper-item.component';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { CwSelectOptionComponent } from './select/select-option/select-option.component';
import { StepperEventsService } from './stepper/services/stepper-events.service';

@NgModule({
    declarations: [
        CwIconComponent,
        CwLoaderComponent,
        CwLoaderInlineComponent,
        LinearChartComponent,
        PlainLoaderComponent,
        CwErrorComponent,
        ChartErrorComponent,
        CwInputComponent,
        CwRadioButtonComponent,
        CwSelectComponent,
        CwSelectOptionComponent,
        CwStepperComponent,
        CwStepperItemComponent
    ],

    providers: [
        CwLoaderService,
        StepperEventsService
    ],

    imports: [
        NgCommon,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CwContactSupportModule,
        ButtonModule,
        CdkOverlayOrigin,
        CdkConnectedOverlay,
    ],

    exports: [
        CwIconComponent,
        CwLoaderComponent,
        CwLoaderInlineComponent,
        LinearChartComponent,
        PlainLoaderComponent,
        CwContactSupportModule,
        CwErrorComponent,
        ChartErrorComponent,
        CwInputComponent,
        CwRadioButtonComponent,
        CwSelectComponent,
        CwSelectOptionComponent,
        CwStepperComponent,
        CwStepperItemComponent
    ]
})
export class CwComponentsModule {
}
